import * as React from 'react';
import { Box, Popover } from 'wix-style-react';
import { httpClient } from '../../../../../../common/utils/httpClient';
import { ContactOwnerButtonContainer } from './ContactOwnerButtonContainer/ContactOwnerButtonContainer';
import { ContactOwnerPopoverContent } from './ContactOwnerPopoverContent/ContactOwnerPopoverContent';

export const ContactOwner = ({ artifactId }) => {
  const [isContactDetailsPopoverOpen, setIsContactDetailsPopoverOpen] =
    React.useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  const [isButtonSelected, setIsButtonSelected] = React.useState(false);
  const [artifactData, setArtifactData] = React.useState({
    jiraProjects: '',
    slackChannels: {},
    company: '',
  });
  const [isFetchingArtifactData, setIsFetchingArtifactData] =
    React.useState(false);

  const showContactDetailsPopover = () => {
    setIsButtonSelected(true);
    setIsContactDetailsPopoverOpen(true);
  };

  const hideContactDetailsPopover = () => {
    setIsContactDetailsPopoverOpen(false);
    if (!isTooltipOpen) {
      setIsButtonSelected(false);
    }
  };

  const showTooltip = () => {
    setIsButtonSelected(true);
    setIsTooltipOpen(true);
  };

  const hideTooltip = () => {
    if (!isContactDetailsPopoverOpen) {
      setIsButtonSelected(false);
    }
    setIsTooltipOpen(false);
  };

  const onContactOwnerButtonClicked = () => {
    if (!isContactDetailsPopoverOpen) {
      showContactDetailsPopover();
      return fetchArtifactIdData();
    } else {
      hideContactDetailsPopover();
    }
  };

  const fetchArtifactIdData = () => {
    if (isContactDetailsPopoverOpen) {
      return;
    }
    setIsFetchingArtifactData(true);
    const base = `${window?.location?.origin}${window?.__BASEURL__}` || '/';
    return httpClient
      .get(`${base}api/v1/code-owners/${artifactId}`)
      .then((result) => {
        setArtifactData(result.data);
      })
      .catch((error) => {
        console.error('error while try to fetch artifact data, ', error);
        window.Sentry.captureException(error);
      })
      .finally(() => {
        setIsFetchingArtifactData(false);
      });
  };

  return (
    <>
      {artifactId && (
        <Box align="right" verticalAlign="middle" direction="horizontal" inline>
          <Popover
            shown={isContactDetailsPopoverOpen}
            flip={false}
            animate
            appendTo="window"
            placement="bottom-end"
            showArrow
            onClickOutside={hideContactDetailsPopover}
            moveBy={{ y: 5 }}
            fixed
          >
            <Popover.Element>
              <ContactOwnerButtonContainer
                onClick={onContactOwnerButtonClicked}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
                isTooltipOpen={isTooltipOpen}
                isSelectedMode={isButtonSelected}
              />
            </Popover.Element>
            <Popover.Content>
              <ContactOwnerPopoverContent
                artifactData={artifactData}
                isFetchingArtifactData={isFetchingArtifactData}
                onCloseButtonClick={hideContactDetailsPopover}
              />
            </Popover.Content>
          </Popover>
        </Box>
      )}
    </>
  );
};
